<div class="group-filter" *ngFor="let filter of dataset.filters">
  <app-group-filter [dataset]="dataset" [filter]="filter" [data]="data" #filterComponents></app-group-filter>
</div>
